import CodeBase from "./CodeBase.js"

// 시나리오 신청 유형

class ScenarioRequestType extends CodeBase {
  constructor() {
    const CODE_MAP = {
      'A' : '표준',
      'B' : '신규'
    };

    super(CODE_MAP);
  }
}

export default ScenarioRequestType;
